(function () {
    'use strict';
    angular.module('GorillaBoy.directives')
    .directive('detailedGroupEntry', ['$timeout', '$q', '$rootScope', '$translate', 'SourceConstant', 'DocumentStateService','GroupService', 'AppConstants', 'ResourceService', 'ModalFactory', 'MessageManager', 'MessageProvider','OrganizationService', 'ClientMetricsService', 'SignalProvider', '$log',
        function ($timeout, $q, $rootScope, $translate, SourceConstant, DocumentStateService, GroupService, AppConstants, ResourceService, ModalFactory, MessageManager, MessageProvider, OrganizationService, ClientMetricsService, SignalProvider, $log) {

            // AppConstant bindings
            var collaboratorTypes = AppConstants.CollaboratorTypes,
                globalRoles = AppConstants.GlobalRoles,
                rolyTypes = AppConstants.RoleTypes,
                METRICS_EVENTS = {
                    GROUP_PRINCIPAL_ROLE_CHANGE: {name: 'GROUP_PRINCIPAL_ROLE_CHANGE'}
                },
                SHARE_RESULT = {
                FEEDBACK_FAILURE: 'FAILED',
                SHARE_FAILURE: 'FAILURE'
            };

            function roleToHumanString (role) {
                switch (role) {
                    case globalRoles.VIEWER:
                        return $translate.instant('RIGHT_NAV.VIEWER');
                    case globalRoles.CONTRIBUTOR:
                        return $translate.instant('RIGHT_NAV.CONTRIBUTOR');
                    case globalRoles.COOWNER:
                        return $translate.instant('RIGHT_NAV.CO_OWNER');
                    default:
                        return $translate.instant('RIGHT_NAV.OWNER');
                }
            }

            // Binds ("import") functions defined in scope.$parent into scope
            function bindParentScopeFunctions (scope, functionMap) {
                var key;

                for (key in functionMap) {
                    if (functionMap.hasOwnProperty(key)) {
                        scope[key] = scope.$parent[functionMap[key]];
                    }
                }
            }

            function getUsersInGroup (group) {
                var deferred = $q.defer();
                var groupUserMarker = null;
                GroupService.getUsersInGroup(group.Id, group.Vendor, ['PRINCIPALS'], groupUserMarker)
                .then(function(res) {
                    if (res && res.Users) {
                        deferred.resolve(res.Users);
                    }

                }, function(error) {
                    deferred.reject(error);
                });

                return deferred.promise;

            }

            return {
                restrict: 'E',
                scope: {
                    group: '=',
                    commentMap: '=',
                    role: '=type',
                    resourceInfo: '=',
                    roleType: '=',
                    onEntityClicked: '&'
                },
                link: function (scope, element, attrs) {
                    scope.parentScope = scope.$parent;
                    scope.groupMembers = [];
                    scope.groupHasComment = false;
                    scope.usersWhoLeftComment = [];
                    scope.isDirect = scope.roleType === rolyTypes.DIRECT;
                    scope.isInherited = scope.roleType === rolyTypes.INHERITED;
                    scope.typeName = roleToHumanString(scope.group.Role);
                    scope.isOwner = scope.group.Role === globalRoles.OWNER;
                    scope.isReadOnly = scope.group.Role === globalRoles.VIEWER;
                    scope.isUser = scope.group.Type === collaboratorTypes.USER;
                    scope.isGroup = scope.group.Type === collaboratorTypes.GROUP;
                    scope.isAnon = scope.group.Type === collaboratorTypes.ANONYMOUS;
                    scope.isDoc = DocumentStateService.contentType !== null;
                    scope.viewerPermissionsOnly = isDocViewerPermissionsOnly(DocumentStateService.currentUserRoles);
                    getUsersInGroup(scope.group).then(function(users) {
                        angular.forEach(users, function(user) {
                            scope.groupMembers.push(user);
                        });

                    }, function() {});

                    // Explicitly "import" functions from parent scope.
                    // TODO: probably move those to something like DocumentUtilities but these functions currently rely
                    // on data stored in scope so it's not a 2-min change.
                    bindParentScopeFunctions(scope, {
                        isPersonSelected: 'isPersonSelected',
                        isGroupSelected: 'isGroupSelected',
                        showRemovePermission: 'showRemovePermission',
                        inRecycleBin: 'inRecycleBin',
                        hasSharePermission: 'hasSharePermission',
                        hasRemoveUserFromSharePermission: 'hasRemoveUserFromSharePermission'
                    });

                    scope.toggleMemberListVisibility = function () {
                        element.find("ul.member-list").slideToggle();
                    };

                    scope.showMemberList = function() {
                        element.find("ul.member-list").show();
                    };

                    scope.setGroupHasComment = function () {
                        scope.groupHasComment = true;
                    };

                    scope.showCommentedUser = function (user) {
                        return scope.commentMap && scope.commentMap[user.Id] && scope.commentMap[user.Id] > 0;
                    };

                    scope.getUsersWhoLeftComment = function() {
                        // update usersWhoLeftComment only when the newValue is different with the old value.
                        // this avoid infinite digest loop error: https://docs.angularjs.org/error/$rootScope/infdig
                        var newValue = scope.groupMembers.filter(scope.showCommentedUser);
                        if (newValue.length != scope.usersWhoLeftComment.length) {
                            scope.usersWhoLeftComment = newValue;
                        }
                        return scope.usersWhoLeftComment;
                    };

                    scope.GlobalRoles = globalRoles;

                    scope.canRemoveUser = function () {
                        var canRemove;

                        if (scope.hasRemoveUserFromSharePermission) {
                            canRemove = scope.hasRemoveUserFromSharePermission();
                        } else {
                            canRemove = scope.hasSharePermission();
                        }

                        return canRemove && !scope.isOwner;
                    };

                    scope.getUserFullName = function(person) {
                        return $translate.instant('RIGHT_NAV.PERSON_NAME', {
                            givenName: $rootScope.escapeHTML(person.GivenName),
                            surname: $rootScope.escapeHTML(person.Surname)
                        });
                    };

                    scope.showPermissionChange = function() {
                        if (!scope.hasSharePermission || !scope.hasSharePermission()) {
                            return false;
                        }
                        if (!scope.isOwner && scope.isDirect) {
                            return true;
                        }
                        return false;
                    };

                    scope.updateRole = function(group, type, resourceInfo) {
                        if (group === undefined || type === undefined || resourceInfo === undefined) {
                            return;
                        }

                        var done = $q.defer(),
                        promise = null;

                        var data = {
                            shareResourceId: resourceInfo.Id,
                            role: type,
                            collaborators: [group],
                            message: "",
                            feedbackRequested: false,
                            feedbackRequestList: [],
                            deadline: null
                        };

                        promise = changePermission(data, resourceInfo.resourceType);

                        promise.then(function success() {
                            MessageManager.addSuccessMessage(MessageProvider.allChangesDone, true);
                            done.resolve();
                        }, function error(errorObj) {
                            $log.error("Failed to update principal for group. ErrorObj: " + JSON.stringify(errorObj));
                            if (resourceInfo.resourceType == AppConstants.ResourceTypes.FILE) {
                                MessageManager.addErrorMessage(MessageProvider.defaultShareFailure);
                            } else if (resourceInfo.resourceType == AppConstants.ResourceTypes.FOLDER) {
                                MessageManager.addErrorMessage(MessageProvider.folderShareFailDefault);
                            }
                            done.reject();
                        });

                        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.GROUP_PRINCIPAL_ROLE_CHANGE, 1);

                        return done.promise;
                    };

                    // Permissions
                    scope.showRemovePermission = function(resourceInfo, principalId, principalName) {
                        var title = $translate.instant('MODAL.DELETE_PERMISSION_MODAL.REMOVE_PERMISSION_TITLE'),
                            message = $translate.instant('MODAL.DELETE_PERMISSION_MODAL.REMOVE_PERMISSION_MESSAGE'),
                            okayButtonText = $translate.instant('GENERAL_LABELS.OK'),
                            cancelButtonText = $translate.instant('GENERAL_LABELS.CANCEL');
                        ModalFactory.showConfirmationModal(title, message, okayButtonText, cancelButtonText).then(function() {
                            scope.removePermission(resourceInfo.Id, principalId, principalName);
                        }, function() {
                            
                        });
                    };

                    scope.removePermission = function(resourceId, removePrincipalId, removePrincipalName) {
                        ResourceService.deleteResourcePermission(resourceId, removePrincipalId)
                        .success(function() {
                            if (removePrincipalName === OrganizationService.ORG_USER_USERNAME) {
                                MessageManager.addSuccessMessage(MessageProvider.folderGroupShareRemovalSuccess);
                            } else {
                                MessageManager.addSuccessMessage(MessageProvider.folderPermissionRemoveSuccess(removePrincipalName));
                            }
                            $rootScope.$broadcast(SignalProvider.Permission.PermissionUpdated);
                            $rootScope.$broadcast(SignalProvider.Permission.PrincipalRemoved);
                        });
                    };

                    function changePermission(data, resourceType) {
                        if (resourceType == AppConstants.ResourceTypes.FILE) {
                            return changeDocumentPermission(data);
                        } else if (resourceType == AppConstants.ResourceTypes.FOLDER) {
                            return changeFolderPermission(data);
                        }
                    }

                    function changeFolderPermission(data) {
                        var done = $q.defer();

                        if (!data) {
                            done.reject();
                            return done.promise;
                        }

                        ResourceService.addResourcePermissions(data.shareResourceId, data.role, data.collaborators, data.message).then(function(response) {
                            response = response.data ? response.data : response;
                            if (response && response.ShareResults) {
                                var allSharesSucceeded = true;
                                angular.forEach(response.ShareResults, function(value) {
                                    if (allSharesSucceeded && value.Status === SHARE_RESULT.SHARE_FAILURE) {
                                        allSharesSucceeded = false;
                                    }
                                    if (value.Status !== SHARE_RESULT.SHARE_FAILURE && scope.group.Id === value.PrincipalId) {
                                        updateGroupInfo(scope.group.Id, value.Role);
                                    }
                                });

                                if (!allSharesSucceeded) {
                                    done.reject({
                                        status: AppConstants.HttpStatuses.NOT_FOUND
                                    });
                                    return done.promise;
                                } else {
                                    // If all the shares are successful
                                    done.resolve();
                                }
                            }
                        }, function(error) {
                            done.reject(error);
                        });

                        return done.promise;
                    }

                    function changeDocumentPermission(data) {
                        if (!data) {
                            done.reject();
                            return;
                        }

                        var done = $q.defer();

                        if (data.collaborators.length > 0) {
                            ResourceService.addResourcePermissions(data.shareResourceId, data.role, data.collaborators, data.message).then(function success(response) {
                                response = response.data ? response.data : response;
                                if (response && response.ShareResults) {
                                    var allSharesSucceeded = true;
                                    angular.forEach(response.ShareResults, function(value) {
                                        if (allSharesSucceeded && value.Status === SHARE_RESULT.SHARE_FAILURE) {
                                            allSharesSucceeded = false;
                                        }
                                        if (value.Status !== SHARE_RESULT.SHARE_FAILURE && scope.group.Id === value.PrincipalId) {
                                            updateGroupInfo(scope.group.Id, value.Role);
                                        }
                                    });

                                    if (!allSharesSucceeded) {
                                        done.reject({
                                            status: AppConstants.HttpStatuses.NOT_FOUND
                                        });
                                        return done.promise;
                                    } else {
                                        // If all the shares are successful
                                        done.resolve();
                                    }
                                }
                            }, function error(response) {
                                done.reject(response);
                            });
                        }

                        return done.promise;
                    }

                    function updateGroupInfo(Id, role) {
                        if (Id !== scope.group.Id) {
                            return;
                        }
                        scope.group.Role = role;
                        scope.typeName = roleToHumanString(scope.group.Role);
                        scope.isOwner = scope.group.Role === globalRoles.OWNER;
                        scope.isReadOnly = scope.group.Role === globalRoles.VIEWER;
                    }

                    scope.$watch('group', function (newValue, oldValue) {
                    });

                    scope.$watch('person', function (newValue, oldValue) {
                        var feedbackUser;

                        // No need to go fetch the feedback color from the DocumentStateService if we already have one.
                        if (newValue !== oldValue && !newValue.color) {
                            feedbackUser = DocumentStateService.feedback.users[newValue.Id];

                            if (feedbackUser) {
                                newValue.color = feedbackUser.color;
                            }
                        }
                    });

                    scope.$watch('usersWhoLeftComment', function (newValue) {
                        if (newValue && newValue.length > 0) {
                            scope.showMemberList();
                        }
                    });

                    function isDocViewerPermissionsOnly(currentUserRoles) {
                        if (currentUserRoles) {
                            for (var i = 0; i < currentUserRoles.length; i++) {
                                if (currentUserRoles[i].role !== globalRoles.VIEWER) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    }
                },
                templateUrl: './shared/detailed_group_entry.html'
            };
        }
    ]);
}());
